// @flow
// THIS FILE IS AUTOMATICALLY GENERATED -- DO NOT EDIT

const Events: Object = {}

// props

type CGPropsCommon = {
  source:
    | 'home_tab'
    | 'accounts'
    | 'payhub'
    | 'payhub_more_menu'
    | 'app_menu'
    | 'external_deeplink_app_copy_creator'
    | 'external_deeplink_app_copy_contributor'
    | 'external_deeplink_web_copy_creator'
    | 'external_deeplink_web_copy_contributor'
    | 'external_deeplink_app_native_share_creator'
    | 'external_deeplink_app_native_share_contributor'
    | 'external_deeplink_web_native_share_creator'
    | 'external_deeplink_web_native_share_contributor'
    | 'external_deeplink_update_email',
} & $Shape<CGPropsCommon>

type CGPropsCommonAny = {
  source?:
    | 'home_tab'
    | 'accounts'
    | 'payhub'
    | 'payhub_more_menu'
    | 'app_menu'
    | 'external_deeplink_app_copy_creator'
    | 'external_deeplink_app_copy_contributor'
    | 'external_deeplink_web_copy_creator'
    | 'external_deeplink_web_copy_contributor'
    | 'external_deeplink_app_native_share_creator'
    | 'external_deeplink_app_native_share_contributor'
    | 'external_deeplink_web_native_share_creator'
    | 'external_deeplink_web_native_share_contributor'
    | 'external_deeplink_update_email',
}

type CGPropsP2pPoolsListShown = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsListCreatePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsListPoolPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
  pool_id: string,
}

type CGPropsP2pPoolsIntroScreenShown = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsIntroScreenShownStartPoolingPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsIntroScreenBackPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsIntroScreenLearnMorePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsCreateScreenShown =
  | {
      page_variant:
        | 'created_empty'
        | 'created_full'
        | 'contributed_empty'
        | 'contributed_full',
    }
  | {
      page_variant:
        | 'created_empty'
        | 'created_full'
        | 'contributed_empty'
        | 'contributed_full',
      xe: string,
      xt: string,
    }

type CGPropsP2pPoolsCreatePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsCreateBackPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full',
}

type CGPropsP2pPoolsEditPhotoPressed = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsCreateSuccessSheetShown = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
}

type CGPropsP2pSuccessScreenShown = {}

type CGPropsP2pPoolsCreateSuccessSheetCopyLinkPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsCreateSuccessSheetSharePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailSharePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
  web_share_button:
    | 'copy'
    | 'email'
    | 'messenger'
    | 'facebook'
    | 'twitter'
    | 'whatsapp',
}

type CGPropsP2pPoolsDetailContributePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailContributeWithPaypalPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailReportPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailBackPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailActivitySeeAllPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailRecentActivityTransactionPressed = {
  activity_type: 'self_contribution' | 'non_creator_contribution',
  page_variant: 'creator' | 'paypal_contributor',
}

type CGPropsP2pPoolsDetailTransferPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailEditPoolPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailEditImagePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailMoreOptionsClosePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailMoreOptionsCreatePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailMoreOptionsPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsEditSuccess = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsEditCloseCancelPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsDetailScreenShown =
  | {
      page_variant: 'creator' | 'paypal_contributor' | 'guest_contributor',
      pool_id: string,
    }
  | {
      page_variant: 'creator' | 'paypal_contributor' | 'guest_contributor',
      pool_id: string,
      xe: string,
      xt: string,
    }

type CGPropsP2pPoolsEditUpdatePressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsEditCloseConfirmPressed = {
  page_variant:
    | 'created_empty'
    | 'created_full'
    | 'contributed_empty'
    | 'contributed_full'
    | 'creator'
    | 'paypal_contributor'
    | 'guest_contributor',
  pool_id: string,
}

type CGPropsP2pPoolsEditPhotoScreenShown = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsEditPhotoPaypalProvidedOptionSelected = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
  selected_photo: string,
}

type CGPropsP2pPoolsEditPhotoTakeNewPhoto = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsEditPhotoChooseExistingPhoto = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsEditPhotoUploadPhotoPressed = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsEditPhotoBackPressed = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsDetailLoginPressed = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsDetailSignUpPressed = {
  page_variant: 'create_flow' | 'edit_flow',
  pool_id: string,
}

type CGPropsP2pPoolsIntroScreenSwipe = {
  page_variant: 'create_flow' | 'edit_flow',
}

type CGPropsP2pFailedCustomerInteractionOccurred = {
  error_code: string,
}

// common props

export let commonProps: Object = {}
Events.initCommonProps = (props: CGPropsCommon) => {
  commonProps = {
    sub_flow: 'pools',
    product: 'p2p',
    ...props,
  }
}
Events.updateCommonProps = (props: CGPropsCommonAny) => {
  commonProps = {
    ...commonProps,
    ...props,
  }
}

// events

Events.p2p_pools_list_shown = (props: CGPropsP2pPoolsListShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_pools_list_shown',
  event_props: 'source, sub_flow, product, event_type, page_variant',
  ...props,
})

Events.p2p_pools_list_create_pressed = (
  props: CGPropsP2pPoolsListCreatePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_pools_list_create_pressed',
  event_props: 'source, sub_flow, product, event_type, page_variant',
  ...props,
})

Events.p2p_pools_list_pool_pressed = (
  props: CGPropsP2pPoolsListPoolPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_pools_list_pool_pressed',
  event_props: 'source, sub_flow, product, event_type, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_intro_screen_shown = (
  props: CGPropsP2pPoolsIntroScreenShown,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_intro_screen_shown',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_pools_intro_screen_shown_start_pooling_pressed = (
  props: CGPropsP2pPoolsIntroScreenShownStartPoolingPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_intro_screen_shown_start_pooling_pressed',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_pools_intro_screen_back_pressed = (
  props: CGPropsP2pPoolsIntroScreenBackPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_intro_screen_back_pressed',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_pools_intro_screen_learn_more_pressed = (
  props: CGPropsP2pPoolsIntroScreenLearnMorePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_intro_screen_learn_more_pressed',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_pools_create_screen_shown = (
  props: CGPropsP2pPoolsCreateScreenShown,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_create_screen_shown',
  event_props: 'source, sub_flow, product, page_variant, xe, xt',
  ...props,
})

Events.p2p_pools_create_pressed = (props: CGPropsP2pPoolsCreatePressed) => ({
  ...commonProps,
  event_name: 'p2p_pools_create_pressed',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_pools_create_back_pressed = (
  props: CGPropsP2pPoolsCreateBackPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_create_back_pressed',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_pools_edit_photo_pressed = (
  props: CGPropsP2pPoolsEditPhotoPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_create_success_sheet_shown = (
  props: CGPropsP2pPoolsCreateSuccessSheetShown,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_create_success_sheet_shown',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_success_screen_shown = (props: CGPropsP2pSuccessScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_success_screen_shown',
  event_props: 'source, sub_flow, product, event_type',
  ...props,
})

Events.p2p_pools_create_success_sheet_copy_link_pressed = (
  props: CGPropsP2pPoolsCreateSuccessSheetCopyLinkPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_create_success_sheet_copy_link_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_create_success_sheet_share_pressed = (
  props: CGPropsP2pPoolsCreateSuccessSheetSharePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_create_success_sheet_share_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_share_pressed = (
  props: CGPropsP2pPoolsDetailSharePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_share_pressed',
  event_props:
    'source, sub_flow, product, page_variant, web_share_button, pool_id',
  ...props,
})

Events.p2p_pools_detail_contribute_pressed = (
  props: CGPropsP2pPoolsDetailContributePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_contribute_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_contribute_with_paypal_pressed = (
  props: CGPropsP2pPoolsDetailContributeWithPaypalPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_contribute_with_paypal_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_report_pressed = (
  props: CGPropsP2pPoolsDetailReportPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_report_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_back_pressed = (
  props: CGPropsP2pPoolsDetailBackPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_back_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_activity_see_all_pressed = (
  props: CGPropsP2pPoolsDetailActivitySeeAllPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_activity_see_all_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_recent_activity_transaction_pressed = (
  props: CGPropsP2pPoolsDetailRecentActivityTransactionPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_recent_activity_transaction_pressed',
  event_props: 'source, sub_flow, product, page_variant, activity_type',
  ...props,
})

Events.p2p_pools_detail_transfer_pressed = (
  props: CGPropsP2pPoolsDetailTransferPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_transfer_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_edit_pool_pressed = (
  props: CGPropsP2pPoolsDetailEditPoolPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_edit_pool_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_edit_image_pressed = (
  props: CGPropsP2pPoolsDetailEditImagePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_edit_image_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_more_options_close_pressed = (
  props: CGPropsP2pPoolsDetailMoreOptionsClosePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_more_options_close_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_more_options_create_pressed = (
  props: CGPropsP2pPoolsDetailMoreOptionsCreatePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_more_options_create_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_more_options_pressed = (
  props: CGPropsP2pPoolsDetailMoreOptionsPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_more_options_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_success = (props: CGPropsP2pPoolsEditSuccess) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_success',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_close_cancel_pressed = (
  props: CGPropsP2pPoolsEditCloseCancelPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_close_cancel_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_screen_shown = (
  props: CGPropsP2pPoolsDetailScreenShown,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_screen_shown',
  event_props: 'source, sub_flow, product, page_variant, pool_id, xe, xt',
  ...props,
})

Events.p2p_pools_edit_update_pressed = (
  props: CGPropsP2pPoolsEditUpdatePressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_update_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_close_confirm_pressed = (
  props: CGPropsP2pPoolsEditCloseConfirmPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_close_confirm_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_photo_screen_shown = (
  props: CGPropsP2pPoolsEditPhotoScreenShown,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_screen_shown',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_photo_paypal_provided_option_selected = (
  props: CGPropsP2pPoolsEditPhotoPaypalProvidedOptionSelected,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_paypal_provided_option_selected',
  event_props:
    'source, sub_flow, product, page_variant, pool_id, selected_photo',
  ...props,
})

Events.p2p_pools_edit_photo_take_new_photo = (
  props: CGPropsP2pPoolsEditPhotoTakeNewPhoto,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_take_new_photo',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_photo_choose_existing_photo = (
  props: CGPropsP2pPoolsEditPhotoChooseExistingPhoto,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_choose_existing_photo',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_photo_upload_photo_pressed = (
  props: CGPropsP2pPoolsEditPhotoUploadPhotoPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_upload_photo_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_edit_photo_back_pressed = (
  props: CGPropsP2pPoolsEditPhotoBackPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_edit_photo_back_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_login_pressed = (
  props: CGPropsP2pPoolsDetailLoginPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_login_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_detail_sign_up_pressed = (
  props: CGPropsP2pPoolsDetailSignUpPressed,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_detail_sign_up_pressed',
  event_props: 'source, sub_flow, product, page_variant, pool_id',
  ...props,
})

Events.p2p_pools_intro_screen_swipe = (
  props: CGPropsP2pPoolsIntroScreenSwipe,
) => ({
  ...commonProps,
  event_name: 'p2p_pools_intro_screen_swipe',
  event_props: 'source, sub_flow, product, page_variant',
  ...props,
})

Events.p2p_failed_customer_interaction_occurred = (
  props: CGPropsP2pFailedCustomerInteractionOccurred,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_failed_customer_interaction_occurred',
  event_props: 'source, sub_flow, product, event_type, error_code',
  ...props,
})

// export

export default Events
